import React, {useEffect, useState, useRef, useCallback} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setHeader } from '../../store/settings/settingsSlice';
import { getBetCategories, getBetQuestions, placeBet, getUserBets, cashoutBet } from '../../store/prediqo/prediqoActions';
import trendingIcon from "../../assets/images/trending.svg";
import teamLogo from "../../assets/images/favAlone-02.png";
import send_icon from "../../assets/images/send-2.svg";
import tick_icon from "../../assets/images/tick-circle.svg";
import tick_icon_blue from "../../assets/images/tick-circle-blue.svg";
import ticket_discount from "../../assets/images/ticket-discount.svg";
import {  Profile2User} from "iconsax-react";
import style from "./prediqo.module.css";
import Pagination from '../Pagination/Pagination';
import Modal from '../modal/Modal';
import { ArrowDown2, Calculator } from "iconsax-react";
import us_icon from "../../assets/images/us.svg";
import ng_icon from "../../assets/images/ng.svg";
import ghana_icon from "../../assets/images/ghanaflag.svg";
import arrow_left from '../../assets/images/arrow-left.svg';
import moneyIcon from '../../assets/images/moneys.svg';
import spin_circle from '../../assets/images/Loader anim.png'
import success_icon from '../../assets/images/success-icon.svg';
import PinInput from "react-pin-input";
import { useNavigate } from 'react-router-dom';
import { fetchExchangeConfig, getWalletBalance } from '../../store/wallet/walletActions';


const PrediqoPage = () => {

    const dispatch = useDispatch();
    const [location, setLocation] = useState("Explore");
    const historyCategories = ['Active', 'Completed', 'Cancelled'];
    const [activeIndex, setActiveIndex] = useState(0);
    const [historyActiveIndex, setHistoryActiveIndex] = useState(0);
    const [putPass, setPutPass] = useState(false);
    const [trPin, setTrPin] = useState(""); 
    const navigate = useNavigate();
    let ele = useRef();
    
    // Redux selectors for categories and questions
    const { categories, categoriesLoading, questions, questionsLoading, questionsCount, userBets, userBetsLoading, userBetsCount, selectedCategory } = useSelector((state) => state.prediqo);
    const walletData = useSelector((state) => state.wallet.data);
    const exchangeConfig = useSelector((state) => state.wallet.exchangeConfig);
    
    let PageSize = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const [currentHistoryPage, setCurrentHistoryPage] = useState(1);

    // Modal states for prediction betting
    const [selectedPrediction, setSelectedPrediction] = useState(null);
    const [isPredictionModal, setIsPredictionModal] = useState(false);

    const [isInitiated, setIsInitiated] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [betSuccessModal, setBetSuccessModal] = useState(false);
    const [isCashoutModal, setIsCashoutModal] = useState(false);
    const [cashoutSuccessModal, setCashoutSuccessModal] = useState(false);
    const [selectedBetForCashout, setSelectedBetForCashout] = useState(null);
    const [isCashingOut, setIsCashingOut] = useState(false);

    // Betting form states
    const [selectedOptions, setSelectedOptions] = useState({});
    const [betAmount, setBetAmount] = useState('');
    const [sourceWallet, setSourceWallet] = useState('');
    const [openFromWallet, setOpenFromWallet] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [potentialReturn, setPotentialReturn] = useState(0);
    const [convertedMinBet, setConvertedMinBet] = useState(0);
    const [convertedMaxBet, setConvertedMaxBet] = useState(0);
    
    // Store selected option details for API call
    const [selectedOptionDetails, setSelectedOptionDetails] = useState(null);
    const [selectedWalletId, setSelectedWalletId] = useState(null);

    // Helper function for currency conversion (similar to Exchange.jsx)
    const convertCurrency = useCallback((amount, fromCurrency = 'USD', toCurrency) => {
        if (!exchangeConfig || !toCurrency || fromCurrency === toCurrency) {
            return amount;
        }

        // Find the exchange rate for the target currency
        const exchangeRateData = exchangeConfig.find(
            (rate) => rate.BaseCurrency.code === fromCurrency && rate.TargetCurrency.code === toCurrency
        );

        if (exchangeRateData) {
            return amount * parseFloat(exchangeRateData.exchange_rate);
        }
        
        return amount;
    }, [exchangeConfig]);

    // Helper function to get currency symbol
    const getCurrencySymbol = (currency) => {
        switch (currency) {
            case 'NGN': return '₦';
            case 'GHS': return '₵';
            case 'USD': return '$';
            default: return '$';
        }
    };

    // Format number with commas
    const formatNumberWithCommas = (value) =>
        new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);


    const getMoreItemsByOffset = (page) => {
        setCurrentPage(page);
        // Calculate the page index for API (0-based)
        const pageIndex = page - 1;
        
        // Fetch questions for the selected category with pagination
        const categoryId = selectedCategory?.id || 0;
        dispatch(getBetQuestions({ 
            category_id: categoryId, 
            page: pageIndex, 
            per_page: PageSize 
        }));
    };

    // Prediction modal handlers - updated to handle option clicks
    const handleOptionClick = (prediction, option, groupIndex = null, optionIndex) => {
        setSelectedPrediction(prediction);
        setIsPredictionModal(true);
        
        // Pre-select the clicked option (single selection)
        const key = groupIndex !== null ? `${groupIndex}-${optionIndex}` : `simple-${optionIndex}`;
        setSelectedOptions({ [key]: true });
        // Store option details for API call
        setSelectedOptionDetails({
            questionId: prediction.id,
            optionId: option.id,
            option: option
        });
        
        setBetAmount('');
        setPotentialReturn(0);
        setErrorMessage('');
        calculatePotentialReturn(option.odds);
    };

    const handleOptionSelect = (groupIndex, optionIndex, option) => {
        const key = `${groupIndex}-${optionIndex}`;
        setSelectedOptions({ [key]: true }); // Single selection - clear others
        console.log(option)
        // Update option details for API call
        setSelectedOptionDetails({
            questionId: selectedPrediction.id,
            optionId: option.id,
            option: option
        });
        
        calculatePotentialReturn(option.odds);
    };

    const handleSimpleOptionSelect = (optionIndex, option) => {
        const key = `simple-${optionIndex}`;
        setSelectedOptions({ [key]: true }); // Single selection - clear others
                console.log(option)

        // Update option details for API call
        setSelectedOptionDetails({
            questionId: selectedPrediction.id,
            optionId: option.id,
            option: option
        });
        
        calculatePotentialReturn(option.odds);
    };

    // Wallet handlers (copied from VirtualCards)
    const toggleFromWallet = () => {
        setOpenFromWallet(!openFromWallet);
    };

    const handleFromWallet = (e) => {
        const selectedCurrency = e.target.textContent;
        const walletId = e.target.id;
        setOpenFromWallet(false);
        setSourceWallet(selectedCurrency);
        setSelectedWalletId(parseInt(walletId));
        setBetAmount('');
        setPotentialReturn(0);
        setErrorMessage("");
        
        // Trigger conversion calculation when wallet is selected
        if (selectedPrediction) {
            const minConverted = convertCurrency(selectedPrediction.min_bet_value, 'USD', selectedCurrency);
            const maxConverted = convertCurrency(selectedPrediction.max_bet_value, 'USD', selectedCurrency);
            
            setConvertedMinBet(minConverted);
            setConvertedMaxBet(maxConverted);
        }
    };

    // const formatNumberWithCommas = (value) =>
    //     new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);

    const formatEndTime = (dateString) => {
        if (!dateString) return "";
        
        const date = new Date(dateString);
        const options = { 
            day: 'numeric', 
            month: 'short', 
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false 
        };
        
        return date.toLocaleDateString('en-GB', options);
    };

    const handleAmountChange = (e) => {
        const inputAmount = e.target.value;
        setBetAmount(inputAmount);

        if (!sourceWallet) {
            setErrorMessage("Please select a source wallet.");
            return;
        }

        // Check minimum bet validation with currency conversion
        if (inputAmount && parseFloat(inputAmount) < convertedMinBet) {
            setErrorMessage(`Amount cannot be less than minimum bet of ${getCurrencySymbol(sourceWallet)}${convertedMinBet.toFixed(2)}`);
            return;
        }

        // Check maximum bet validation with currency conversion
        if (inputAmount && parseFloat(inputAmount) > convertedMaxBet) {
            setErrorMessage(`Amount cannot exceed maximum bet of ${getCurrencySymbol(sourceWallet)}${convertedMaxBet.toFixed(2)}`);
            return;
        }

        // Check wallet balance
        const walletBalance = walletData?.fiatWallets.find(wallet => 
            sourceWallet.includes(wallet.Currency.code))?.balance || 0;
        
        if (inputAmount && parseFloat(inputAmount) > parseFloat(walletBalance)) {
            setErrorMessage(`Insufficient balance. Available: ${getCurrencySymbol(sourceWallet)}${walletBalance}`);
            return;
        }

        setErrorMessage("");
        
        // Recalculate potential return when amount changes
        if (selectedOptionDetails && inputAmount) {
            const cleanAmount = parseFloat(inputAmount);
            const potential = cleanAmount * parseFloat(selectedOptionDetails.option.odds);
            setPotentialReturn(potential);
        }
    };

    const calculatePotentialReturn = (odds) => {
        if (betAmount && odds) {
            const cleanAmount = parseFloat(betAmount);
            const potential = cleanAmount * parseFloat(odds);
            setPotentialReturn(potential);
        }
    };

    const handleClosePredictionModal = () => {
        setIsPredictionModal(false);
        setSelectedPrediction(null);
        setSelectedOptions({});
        setBetAmount('');
        setSourceWallet('');
        setErrorMessage('');
        setPotentialReturn(0);
        setSelectedOptionDetails(null);
        setSelectedWalletId(null);
        setTrPin('');
        setIsInitiated(false);
        setPutPass(false);
    
        // Clear pin input if it exists
        if (ele && ele.clear) {
            ele.clear();
        }
    };

    const handleReview = () => {
        if (!betAmount || !sourceWallet) {
            setErrorMessage("Please fill in all fields");
            return;
        }

        const amount = parseFloat(betAmount);
        
        // Validate against converted min/max
        if (amount < convertedMinBet) {
            setErrorMessage(`Amount cannot be less than minimum bet of ${getCurrencySymbol(sourceWallet)}${convertedMinBet.toFixed(2)}`);
            return;
        }

        if (amount > convertedMaxBet) {
            setErrorMessage(`Amount cannot exceed maximum bet of ${getCurrencySymbol(sourceWallet)}${convertedMaxBet.toFixed(2)}`);
            return;
        }

        // Validate against wallet balance
        const walletBalance = walletData?.fiatWallets.find(wallet => 
            sourceWallet.includes(wallet.Currency.code))?.balance || 0;
        
        if (amount > parseFloat(walletBalance)) {
            setErrorMessage(`Insufficient balance. Available: ${getCurrencySymbol(sourceWallet)}${walletBalance}`);
            return;
        }

        setErrorMessage("");
        setIsInitiated(true);
    };

const handlePlaceBet = () => {
    // Show transaction pin modal
    setPutPass(true);
};

const handlePinSubmit = async () => {
    if (!trPin || trPin.length < 5) {
        // You can add error handling here
        return;
    }

    if (!selectedOptionDetails || !selectedWalletId || !betAmount) {
        // Handle missing information
        return;
    }

    // Close pin modal and show loading
    setPutPass(false);
    setIsPredictionModal(false);
    setIsOpen(true);

    try {
        // Dispatch the place bet action
        await dispatch(placeBet({
            questionId: selectedOptionDetails.questionId,
            optionId: selectedOptionDetails.optionId,
            transactionPin: trPin,
            walletId: selectedWalletId,
            amount: parseFloat(betAmount)
        })).unwrap();

        // Success - show success modal
        setIsOpen(false);
        setBetSuccessModal(true);

        // move to history tab and history api call
        setLocation("History");
        setCurrentPage(1);
        setHistoryActiveIndex(0);
        dispatch(getUserBets({ status: 'ACTIVE', page: 0, per_page: PageSize }));
              
        // Reset all form states
        resetBettingForm();
    
    
    } catch (error) {
        // Error handling
        setIsOpen(false);
    
      // Reopen the pin modal for retry
        setPutPass(true);
        setIsPredictionModal(true);

        // You can show an error message here
        console.error("Bet placement failed:", error);
    }
};

const resetBettingForm = () => {
    setIsPredictionModal(false);
    setSelectedPrediction(null);
    setSelectedOptions({});
    setBetAmount('');
    setSourceWallet('');
    setErrorMessage('');
    setPotentialReturn(0);
    setIsInitiated(false);
    setSelectedOptionDetails(null);
    setSelectedWalletId(null);
    setTrPin('');
    setPutPass(false);

    // Clear pin input only on success
    if (ele && ele.clear) {
        ele.clear();
    }
};


    // Transform BetOptions API data to existing card format
    const transformBetOptions = (betOptionsArray) => {
        if (!betOptionsArray || !Array.isArray(betOptionsArray)) return "Bet Options";

        // Group options by option_text
        const grouped = betOptionsArray.reduce((acc, betOption) => {
            const { option_text, options } = betOption;
            const groupLabel = option_text || "Bet options";
            
            if (!acc[groupLabel]) {
                acc[groupLabel] = [];
            }
            
            // Transform each nested option to match existing format
            options.forEach(opt => {
                acc[groupLabel].push({
                    label: opt.bet_side,
                    odds: opt.odd,
                    active: false,
                    id: opt.id,
                });
            });
            
            return acc;
        }, {});

        // Convert to groupedOptions format
        return Object.entries(grouped).map(([label, options]) => ({
            label,
            options
        }));
    };

    // Handle click outside for dropdown
    // useEffect(() => {
    //     let handler = (e) => {
    //         // Check if click is inside the dropdown
    //         const isDropdownClick = e.target.closest('.select') || 
    //                                e.target.id === "from_wallet" || 
    //                                e.target.closest('[id="from_wallet"]') ||
    //                                e.target.closest('.option');
            
    //         if (!isDropdownClick) {
    //             setOpenFromWallet(false);
    //         }
    //     };
    //     document.addEventListener("mousedown", handler);

    //     return () => {
    //         document.removeEventListener("mousedown", handler);
    //     };
    // }, []);

     useEffect(() => {
            dispatch(setHeader("Prediqo"));
            dispatch(getBetCategories());
            dispatch(fetchExchangeConfig())
            dispatch(getWalletBalance());
            // Fetch trending questions by default
            dispatch(getBetQuestions({ category_id: 0, page: 0, per_page: PageSize }));
            // Fetch user bets with default status (ACTIVE)
            dispatch(getUserBets({ status: 'ACTIVE', page: 0, per_page: PageSize }));
     }, [dispatch, PageSize]);

     // Convert bet limits when prediction or wallet changes
     useEffect(() => {
        if (selectedPrediction && sourceWallet) {
            const minConverted = convertCurrency(selectedPrediction.min_bet_value, 'USD', sourceWallet);
            const maxConverted = convertCurrency(selectedPrediction.max_bet_value, 'USD', sourceWallet);
            
            setConvertedMinBet(minConverted);
            setConvertedMaxBet(maxConverted);
        } else {
            setConvertedMinBet(selectedPrediction?.min_bet_value || 0);
            setConvertedMaxBet(selectedPrediction?.max_bet_value || 0);
        }
    }, [selectedPrediction, sourceWallet, exchangeConfig, convertCurrency]);

     // Category selection handler
     const handleCategoryClick = (category) => {
        setCurrentPage(1); // Reset to first page when changing category
        dispatch(getBetQuestions({ category_id: category.id, page: 0, per_page: PageSize }));
     };

     // History category selection handler
     const handleHistoryCategoryClick = (categoryIndex) => {
        console.log(categoryIndex)
        setHistoryActiveIndex(categoryIndex);
        setCurrentHistoryPage(1); // Reset to first page when changing status
        const statusMap = ['ACTIVE', 'COMPLETED', 'CANCELLED'];
        const status = statusMap[categoryIndex];
        dispatch(getUserBets({ status, page: 0, per_page: PageSize }));
     };

     // History pagination handler
     const getMoreHistoryItemsByOffset = (page) => {
        setCurrentHistoryPage(page);
        const pageIndex = page - 1;
        const statusMap = ['ACTIVE', 'COMPLETED', 'CANCELLED'];
        const status = statusMap[historyActiveIndex];
        dispatch(getUserBets({ status, page: pageIndex, per_page: PageSize }));
     };

     // Transform API response to match current UI structure
     const transformUserBetsData = (bets) => {
        if (!bets || !Array.isArray(bets)) return [];
        
        return bets.map(bet => ({
            id: bet.id,
            logo: bet.BetQuestion?.image_url || teamLogo, // Use API image or fallback
            question: bet.BetQuestion?.question_text || 'Unknown question',
            userBet: bet.BetOption?.bet_side || 'Unknown',
            odd: bet.odd,
            stake: bet.amount,
            bet_question_id: bet.bet_question_id,
            currency: bet.Wallet?.Currency.code === "USD" ? "$" : bet.Wallet?.Currency.code === "NGN" ? "₦" : bet.Wallet?.Currency.code === "GHS" ? "₵" : bet.Wallet?.Currency.code,
            potentialWin: bet.potential_payout,
            cashout: bet.amount * bet.BetOption.cash_out_odd || 0,
            users: bet.BetQuestion?.bet_count || 0,
            user_count: bet.BetQuestion?.user_count || 0,
            cashOutStatus: bet.BetOption?.is_cash_out_active || false,
            status: bet.status === 'ACTIVE' ? 'Active' : bet.status === 'WON' ? 'Won' : bet.status === 'LOST' ? 'Lost' : bet.status === 'CASHED_OUT' ? 'Cashed Out' : bet.status === "PENDING_RESULT" ? 'Pending' : 'Cancelled',
            ends: formatEndTime(bet.BetQuestion?.end_time),
            paymentStatus: bet.paymentStatus,
            // Additional fields for dynamic button
            originalStatus: bet.status, // Keep original API status
            isCashedOut: bet.is_cashed_out,
            amountWon: bet.status === 'WON' ? bet.potential_payout : 0,
            amountLost: bet.status === 'LOST' ? bet.amount : 0,
            amountCashedOut: bet.cash_out_amount || 0
        }));
     };

     // Helper function to get dynamic button content and state
     const getBetButtonConfig = (bet) => {
        switch (bet.originalStatus) {
            case 'WON':
                return {
                    text: `Won ${bet.currency}${bet.amountWon.toFixed(2)}`,
                    disabled: true,
                    className: style.betWonBtn,
                    onClick: null
                };
            case 'LOST':
                return {
                    text: `Lost ${bet.currency}${bet.amountLost.toFixed(2)}`,
                    disabled: true,
                    className: style.betLostBtn,
                    onClick: null
                };
            case 'CASHED_OUT':
                return {
                    text: `Cashed out ${bet.currency}${bet.amountCashedOut.toFixed(2)}`,
                    disabled: true,
                    className: style.betCashedOut,
                    onClick: null
                };
            case 'ACTIVE':
                return {
                    text: bet.cashOutStatus ? `Cashout ${bet.currency}${bet.cashout.toFixed(2)}` : 'Cashout not available',
                    disabled: !bet.cashOutStatus,
                    className: bet.cashOutStatus ? style.betCashout : style.betCashoutDisabled,
                    onClick: bet.cashOutStatus ? () => handleCashoutClick(bet) : null
                };
            default:
                return {
                    text: 'Cashout not available',
                    disabled: true,
                    className: style.betCashoutDisabled,
                    onClick: null
                };
        }
     };

     // Add these handler functions
        const handleCashoutClick = (bet) => {
            setSelectedBetForCashout(bet);
            setIsCashoutModal(true);
        };

        const handleCashoutConfirm = async () => {
            setIsCashingOut(true);
            setIsCashoutModal(false);
            
            try {
                // Dispatch the cashout bet API
                await dispatch(cashoutBet({
                    betId: selectedBetForCashout.id
                })).unwrap();
                
                // Success - close loading and show success modal
                setIsCashingOut(false);
                setCashoutSuccessModal(true);
                
                // Refresh the user bets to reflect the cashout
                const statusMap = ['ACTIVE', 'COMPLETED', 'CANCELLED'];
                const status = statusMap[historyActiveIndex];
                dispatch(getUserBets({ status, page: currentHistoryPage - 1, per_page: PageSize }));
                
            } catch (error) {
                // Error handling - close loading and optionally show error
                setIsCashingOut(false);
                console.error("Cashout failed:", error);
                
                // You can add an error toast or modal here
                // For now, we'll just log the error
                // Optional: Add error state and modal for user feedback
            }
        };

    return (
        <>


  {/* PREDICTION BETTING MODAL */}
        <Modal
    canClose={true}
    modalOpen={isPredictionModal}
    setModalOpen={handleClosePredictionModal}
    title=""
    minWidth='40%'
>
    {selectedPrediction && (
        <div className={style.predictionModalContent}>
            {!isInitiated ? (
                // Existing form content
                <>
                <div className={style.predictionModalContent}>
                    {/* Header Section */}
                    <div className={style.predictionModalHeader}>
                        <h3 className={style.modalTitle}>{selectedPrediction.question}</h3>
                        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                        <button onClick={() => navigate(`/bet-detail/${selectedPrediction.id}`)} className={style.showDetailsBtn}>
                            Show full details
                            <img src={send_icon} alt="info icon" />
                        </button>
                        </div>
                    </div>

                    {/* Betting Options Section */}
                    <div className={style.bettingOptionsSection}>
                        {/* For groupedOptions predictions */}
                        {selectedPrediction.groupedOptions ? (
                            selectedPrediction.groupedOptions.map((group, gIdx) => (
                                <div key={gIdx} style={{marginBottom: '15px'}}>
                                    <p style={{color: '#000000', fontSize: '14px', marginBottom: '10px', textAlign: 'left'}}>
                                        {group.label}
                                    </p>
                                    <div className={style.groupOptions}>
                                        {group.options.map((opt, index) => (
                                            <div
                                                key={index}
                                                className={`${style.modalGroupOption}  ${
                                                    selectedOptions[`${gIdx}-${index}`] ? (
                                                        opt.label === "yes" ? style.modalActiveOptionYes : style.modalActiveOptionYes
                                                    ) : ''
                                                }`}
                                                onClick={() => handleOptionSelect(gIdx, index, opt)}
                                                style={{cursor: 'pointer', position: 'relative'}}
                                            >
                                                <span style={{textTransform: 'capitalize'}}>{opt.label}</span>
                                                <strong className={selectedOptions[`${gIdx}-${index}`] ? (
                                                    opt.label === "yes" ? style.activeOptionYesStrong : style.activeOptionYesStrong
                                                ) : ''}>{opt.odds}</strong>
                                                {selectedOptions[`${gIdx}-${index}`] && (
                                                    <img src={tick_icon} alt="Selected" className={style.tickIcon} />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))
                        ) : (
                            /* For simple Yes/No options */
                            <div style={{marginBottom: '15px'}}>
                                <div className={style.options}>
                                    {selectedPrediction.options?.map((opt, index) => (
                                        <div
                                            key={index}
                                            className={`${style.modalOption} ${
                                                selectedOptions[`simple-${index}`] ? (
                                                    opt.label === "yes" ? style.modalActiveOptionYes : style.modalActiveOptionNo
                                                ) : ''
                                            }`}
                                            onClick={() => handleSimpleOptionSelect(index, opt)}
                                            style={{cursor: 'pointer', position: 'relative'}}
                                        >
                                            <span>{opt.label}</span>
                                            <strong className={selectedOptions[`simple-${index}`] ? (
                                                opt.label === "yes" ? style.activeOptionYesStrong : style.activeOptionNoStrong
                                            ) : ''}>{opt.odds}</strong>
                                            {selectedOptions[`simple-${index}`] && (
                                                <img src={tick_icon} alt="Selected" className={style.tickIcon} />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Fund From Section - VirtualCards Style */}
                    <div>
                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                            <label htmlFor="from_wallet">Fund From</label>
                            {sourceWallet ? 
                                <p style={{margin: '0px', color: '#40196D', fontWeight: 500, fontSize: 14}}>
                                    Bal: {sourceWallet === "NGN" ? '₦' : sourceWallet === "GHS" ? '₵' : '$'}
                                    {sourceWallet && (walletData.fiatWallets.find(wallet => sourceWallet.includes(wallet.Currency.code))?.balance || '0.00')}
                                </p> : null}
                        </div>
                        <div className={style.select} style={{marginTop: '10px'}}>
                            <div id="from_wallet"
                                onClick={toggleFromWallet}
                                name="from_wallet" className={style.selectInput}>
                                <div className={style.walletDiv}>
                                    {sourceWallet && (
                                        <img
                                            style={{ width: "20px", height: '20px', borderRadius: '50%'}}
                                            src={sourceWallet === "NGN" ? ng_icon : sourceWallet === "GHS" ? ghana_icon : sourceWallet === "USD" ? us_icon: ""} 
                                            alt="country icon" 
                                        />
                                    )}
                                    <p style={{fontWeight: `${sourceWallet ? 600: 400}`, marginBottom: '0px'}} className={style.walletTitle}>
                                        {sourceWallet ? sourceWallet : 'Select wallet'}
                                    </p>
                                </div>
                            
                                <ArrowDown2
                                    style={{
                                        transform: openFromWallet === true
                                            ? "translateY( -50%) rotate(-540deg)"
                                            : "translateY( -50%) rotate(0deg)",
                                        pointerEvents: "none",
                                    }}
                                    className={style.dropDown}
                                    size="20"
                                    color="#909090"
                                    variant="Bold"
                                />
                            </div>
                            <div
                                style={{
                                    height: openFromWallet === true ? "fit-content" : "0px",
                                }}
                                className={style.option}
                            >
                                {walletData ? (
                                    walletData.fiatWallets.map((item, index) => (
                                        <p
                                            id={item.id}
                                            key={item.id}
                                            style={{
                                                borderBottom: walletData.fiatWallets.length - 1 === index ? "none" : "1px #90909039 solid;",
                                            }}
                                            onClick={(e) => {
                                                handleFromWallet(e);
                                            }}
                                        >
                                            {item.Currency.code}
                                        </p>
                                    ))
                                ) : (
                                    <p>Sorry, no wallets here</p>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className={style.labelPut} style={{marginTop: '15px', marginBottom: '0px'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <label htmlFor="amount">Amount<span style={{color:'#FF0000'}}>*</span></label>
                            {selectedPrediction && sourceWallet && (
                                <div style={{textAlign: 'right'}}>
                                    <span style={{
                                        color: '#40196D', 
                                        fontSize: '12px', 
                                        fontWeight: '500',
                                        display: 'block'
                                    }}>
                                        Min: {getCurrencySymbol(sourceWallet)}{formatNumberWithCommas(convertedMinBet.toFixed(2))}
                                    </span>
                                    <span style={{
                                        color: '#40196D', 
                                        fontSize: '12px', 
                                        fontWeight: '500'
                                    }}>
                                        Max: {getCurrencySymbol(sourceWallet)}{formatNumberWithCommas(convertedMaxBet.toFixed(2))}
                                    </span>
                                </div>
                            )}
                        </div>
                        <div className={style.input}>
                            <input
                                type="number"
                                name="amount"
                                placeholder={`Enter amount (Min: ${getCurrencySymbol(sourceWallet || 'USD')}${sourceWallet ? formatNumberWithCommas(convertedMinBet.toFixed(2)) : selectedPrediction?.min_bet_value || 0})`}
                                value={betAmount}
                                onChange={handleAmountChange} 
                                min={convertedMinBet}
                                max={convertedMaxBet}
                                step="0.01"
                            />
                            {errorMessage && <p style={{ color: "#FF0000", fontSize: '12px', marginTop: '5px', textAlign:'left', marginBottom: '0px' }}>{errorMessage}</p>}
                        </div>
                    </div>

               

                    {/* Potential Return */}
                    <div className={style.potentialReturn}>
                        <Calculator size="20" color="#40196D" />
                        <span>Potential Return = {sourceWallet} {formatNumberWithCommas(potentialReturn.toFixed(2))}</span>
                    </div>

                    {/* Review Button */}
                    <button 
                        className={style.reviewButton}
                        onClick={handleReview}
                        disabled={
                            !betAmount || 
                            !sourceWallet || 
                            parseFloat(betAmount || 0) < convertedMinBet || 
                            parseFloat(betAmount || 0) > convertedMaxBet ||
                            parseFloat(betAmount || 0) > parseFloat(walletData?.fiatWallets.find(wallet => 
                                sourceWallet.includes(wallet.Currency.code))?.balance || 0) ||
                            !!errorMessage
                        }
                    >
                        Review
                    </button>
                </div>
        

                </>
            ) : (
                // Review section
                <div style={{marginTop: '20px'}}>
                    <div  onClick={() => setIsInitiated(false)} style={{width: '20px', height: '20px', background: '#40196d1a', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'}}>
                            <img src={arrow_left} alt="arrow left" />
                        </div>

                    <div style={{
                        background: '#F5F3F7', 
                        marginTop: '20px', 
                        borderRadius: '20px', 
                        padding: '25px'
                    }}>
                        <p style={{
                            color: '#212121', 
                            fontWeight: '400', 
                            fontSize: 14, 
                            marginBottom: 20,
                            textAlign: 'left',
                        }}>
                            Please review your bet details
                        </p>

                        <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <img 
                                    src={sourceWallet === "NGN" ? ng_icon : sourceWallet === "GHS" ? ghana_icon : sourceWallet === "USD" ? us_icon : moneyIcon} 
                                    alt='wallet icon' 
                                    style={{ width: "20px", height: '20px', borderRadius: '50%'}}
                                />
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Fund From</h6>
                                <p style={{marginBottom: 0, color: '#212121', fontWeight: '400', fontSize: 14}}>
                                    {sourceWallet} Wallet
                                </p>
                            </div>
                        </div>

                        {selectedOptionDetails && (
                            <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                                <div>
                                    <img src={tick_icon_blue} alt='selected option' />
                                </div>
                                <div>
                                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>You picked</h6>
                                    <p style={{marginBottom: 0, color:  `${selectedOptionDetails.option.label === "yes" ? "#40196D" : "#C02428"}`, fontWeight: '400',textAlign: 'left', fontSize: 14, textTransform: 'capitalize'}}>
                                        {selectedOptionDetails.option.label}
                                    </p>
                                </div>
                            </div>
                        )}

                        <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <img src={ticket_discount} alt='ticket_discount icon' />
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Odd</h6>
                                <p style={{marginBottom: 0, color: '#212121', fontWeight: '400',textAlign: 'left', fontSize: 14}}>
                                    {selectedOptionDetails?.option.odds || 'N/A'}
                                </p>
                            </div>
                        </div>

                         <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <img src={moneyIcon} alt='bet amount icon' />
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Bet Amount</h6>
                                <p style={{marginBottom: 0, color: '#212121',textAlign: 'left', fontWeight: '400', fontSize: 14}}>
                                    {sourceWallet === "NGN" ? '₦' : sourceWallet === "GHS" ? '₵' : '$'}{betAmount || '0.00'}
                                </p>
                            </div>
                        </div>

                         <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <img src={moneyIcon} alt='profit icon' />
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Profit if Bet wins</h6>
                                <p style={{marginBottom: 0, color: '#212121',textAlign: 'left', fontWeight: '400', fontSize: 14}}>
                                    {sourceWallet === "NGN" ? '₦' : sourceWallet === "GHS" ? '₵' : '$'}{potentialReturn.toFixed(2)} (+{sourceWallet === "NGN" ? '₦' : sourceWallet === "GHS" ? '₵' : '$'}{(potentialReturn - parseFloat(betAmount || 0)).toFixed(2)})
                                </p>
                            </div>
                        </div>

                        <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <img src={moneyIcon} alt='limits icon' />
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Bet Limits</h6>
                                <p style={{marginBottom: 0, color: '#212121',textAlign: 'left', fontWeight: '400', fontSize: 14}}>
                                    Min: {getCurrencySymbol(sourceWallet)}{formatNumberWithCommas(convertedMinBet.toFixed(2))} - Max: {getCurrencySymbol(sourceWallet)}{formatNumberWithCommas(convertedMaxBet.toFixed(2))}
                                </p>
                            </div>
                        </div>

                        <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <img src={moneyIcon} alt='return icon' />
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Total Potential Return</h6>
                                <p style={{marginBottom: 0, color: '#212121',textAlign: 'left', fontWeight: '400', fontSize: 14}}>
                                    {sourceWallet === "NGN" ? '₦' : sourceWallet === "GHS" ? '₵' : '$'}{potentialReturn.toFixed(2)}
                                </p>
                            </div>
                        </div>
                          <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="#40196D" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Date</h6>
                                <p style={{marginBottom: 0, color: '#212121',textAlign: 'left', fontWeight: '400', fontSize: 14}}>
                                  {new Date().toLocaleDateString('en-GB', { 
                                    day: 'numeric', 
                                    month: 'short', 
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                  })}
                                </p>
                            </div>
                        </div>
                    </div>

                    <button 
                        onClick={handlePlaceBet}
                        style={{marginTop: '20px'}} 
                        className={style.save}
                    >
                        Confirm Bet
                    </button>
                </div>
            )}
        </div>
    )}
        </Modal>

           {/* MODAL FOR TRANSACTION PIN */}
        <Modal canClose={true} modalOpen={putPass} setModalOpen={setPutPass}>
            <div className={style.setTrPin}>
            <h2 className={style.pinHead}>Transaction Pin</h2>
            <p style={{textAlign: 'left'}}>Please input your transaction pin</p>
            <div className={style.inputs2}>
                <PinInput
                length={5}
                initialValue=""
                secret={true}
                ref={(n) => {
                    ele = n;
                }}
                onChange={(value, index) => {
                    setTrPin(value);
                }}
                type="numeric"
                inputMode="number"
                style={{ padding: "10px", margin: "0 auto 0 auto" }}
                inputStyle={{ border: "1px solid", borderColor: "#909090" }}
                inputFocusStyle={{
                    border: "2px solid",
                    borderColor: "#40196D",
                }}
                onComplete={(value, index) => {
                    setTrPin(value);
                }}
                autoSelect={true}
                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                value={trPin}
                />
            </div>
            <button
                className={style.save}
                onClick={handlePinSubmit}
            >
                Place Bet
            </button>
            </div>
        
        </Modal>

        {/* Loading Modal */}
         <Modal
        canClose={false}
        modalOpen={isOpen}
        setModalOpen={setIsOpen}
      >
        <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={spin_circle} alt="spin circle" className={style.animate_spin} />
            </div>

            <div>
                <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>
                    Placing your bet
                 </h4>
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                  Please wait...
                </p>
               
            </div>
        </div>

        </Modal>

        {/* Cashout Confirmation Modal */}
        <Modal
            title="Cashout Confirmation"
            minWidth="40%"
            canClose={true}
            modalOpen={isCashoutModal}
            setModalOpen={setIsCashoutModal}
        >
            <div style={{padding: '1rem'}}>
                <p style={{
                    color: '#B6B6B6', 
                    fontSize: '14px',
                    textAlign: 'center',
                    marginBottom: '20px',
                    maxWidth: '400px',
                    margin: 'auto'
                }}>
                    You are about to cash out. The amount will be credited to the account used to place the original bet, are you sure you want to proceed?
                </p>
                
                <div style={{
                    display: 'flex',
                    gap: '10px',
                    justifyContent: 'center',
                    marginTop: '20px'
                }}>
                    <button 
                        onClick={() => setIsCashoutModal(false)}
                        className={style.cancelBtn}
                    >
                        Cancel
                    </button>
                    <button 
                        onClick={handleCashoutConfirm}
                        className={style.save}

                    >
                        Proceed
                    </button>
                </div>
            </div>
        </Modal>


        {/* Loading Modal */}
            <Modal
        canClose={false}
        modalOpen={isCashingOut}
        setModalOpen={setIsCashingOut}
      >
        <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={spin_circle} alt="spin circle" className={style.animate_spin} />
            </div>

            <div>
                <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>
                    Initiating Cashout
                 </h4>
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                  Please wait...
                </p>
               
            </div>
        </div>

        </Modal>

        {/* Cashout Success Modal */}
        <Modal
            title="Cashout Initiated!"
            minWidth="40%"
            canClose={true}
            modalOpen={cashoutSuccessModal}
            setModalOpen={setCashoutSuccessModal}
        >
            <div style={{padding: '2rem', textAlign: 'center'}}>
                <img src={success_icon} alt="success" style={{marginBottom: '1rem'}} />
                <p
                style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}
                >Your cash out was successfully initiated. You’ll be notified after the bet due date.</p>
                <button 
                    onClick={() => setCashoutSuccessModal(false)}
                    className={style.save}
                    style={{marginTop: '1rem'}}
                >
                    Done
                </button>
            </div>
        </Modal>

        {/* Success Modal */}
        <Modal
            title='Bet Placed Successfully'
            minWidth='30%'
            canClose={true}
            modalOpen={betSuccessModal}
            setModalOpen={setBetSuccessModal}
        >
           <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={success_icon} alt="spin circle" />
            </div>

            <div>
            
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                     Your bet was successfully placed.
                        You’ll be notified after the bet due date.
                </p>
            </div>

            <button onClick={() => setBetSuccessModal(false)} style={{marginTop: '20px'}} className={style.save}>
               Place Another Bet
            </button>

        </div>
        </Modal>

         <div
            className={style.cashTabs}
        >
            <ul>
             <li
                onClick={() => {
                    setLocation('Explore');
                    setActiveIndex(0);
                    setCurrentPage(1);
                    dispatch(getBetQuestions({ category_id: 0, page: 0, per_page: PageSize }));
                }}
                style={{
                borderBottom: location === 'Explore'
                    ? "3px #40196D solid"
                    : "0px #90909039 solid",
                }}
                 >
                <div>
                <p
                    style={{
                    color: location === 'Explore' ? "#40196D" : "#C1C1C1",
                    }}
                >
                    Explore
                </p>
                </div>
             </li>
             <li
               onClick={() => {
                    setLocation('History');
                    setCurrentHistoryPage(1);
                    setHistoryActiveIndex(0);
                    dispatch(getUserBets({ status: 'ACTIVE', page: 0, per_page: PageSize }));
                }}
                style={{
                borderBottom: location === 'History'
                    ? "3px #40196D solid"
                    : "0px #90909039 solid",
                }}
                 >
                <div>
                <p
                    style={{
                    color: location === 'History' ? "#40196D" : "#C1C1C1",
                    }}
                >
                    History
                </p>
                </div>
             </li>
            
            </ul>
        </div>

        {/* Explore Section */}
        {location === "Explore" && (
            <div className={style.exploreSection}>
                
                <div className={style.wrapper}>
                        {/* Tabs */}
                        <div className={style.tabs}>
                            {categoriesLoading ? (
                                <p>Loading categories...</p>
                            ) : (
                                // Prepend Trending category to the list
                                [{ id: 0, name: 'Trending' }, ...categories].map((category, index) => (
                                <button
                                    key={category.id || index}
                                    className={`${style.tab} ${activeIndex === index ? style.activeTab : ''}`}
                                    onClick={() => {
                                        setActiveIndex(index);
                                        handleCategoryClick(category);
                                    }}
                                >
                                    {index === 0 && (
                                        <img
                                            src={trendingIcon}
                                            alt="Trending Icon"
                                        />
                                        )}
                                    {category.name || category}
                                </button>
                                ))
                            )}
                        </div>

                        {/* Banner */}
                        <div className={style.banner}>
                            <div className={style.bannerContent}>
                                <p className={style.subtitle}>Win Big on</p>
                                <h2 className={style.title}>Prediqo <span>by Astro Africa</span></h2>
                            </div>
                        </div>
                </div>

              <div className={style.grid}>
                    {questionsLoading ? (
                        // Loading state
                        Array.from({ length: 6 }).map((_, idx) => (
                            <div key={idx} className={style.skeletonCard}>
                                <div className={style.skeletonHeader}>
                                    <div className={style.skeletonLogo}></div>
                                    <div className={style.skeletonText}>
                                        <div className={style.skeletonLine}></div>
                                        <div className={style.skeletonLine} style={{width: '80%'}}></div>
                                    </div>
                                </div>
                                <div className={style.skeletonOptions}>
                                    <div className={style.skeletonOption}></div>
                                    <div className={style.skeletonOption}></div>
                                </div>
                                <div className={style.skeletonFooter}>
                                    <div className={style.skeletonFooterItem}></div>
                                    <div className={style.skeletonFooterItem}></div>
                                </div>
                            </div>
                        ))
                    ) : questions && questions.length > 0 ? (
                        // Questions available
                        questions.map((item, idx) => {
                            // Transform BetOptions if present
                            const transformedOptions = item.BetOptions ? transformBetOptions(item.BetOptions) : null;
                            const itemWithTransformed = {
                                ...item,
                                groupedOptions: transformedOptions || item.groupedOptions
                            };

                            return (
                                <div onClick={()=>navigate(`/bet-detail/${item.id}`)} className={style.card} key={idx}>
                                    <div className={style.header}>
                                        <img src={item?.image_url || teamLogo} alt="Team Logo" className={style.logo} />
                                        <p className={style.question}>{item.question_text}</p>
                                    </div>

                                    {/* RENDER GROUPED OPTIONS */}
                                    <div style={{display: 'flex', flexDirection:'column', gap: '10px'}} className="flex flex-col gap-3">
                                        {itemWithTransformed.groupedOptions?.map((group, gIdx) => (
                                            <div key={gIdx} style={{display: 'flex', flexDirection:'row', alignItems: 'center', justifyContent: 'space-between'}}>
                                                <p style={{color: '#000000', fontSize: '14px'}}>
                                                    {group.label}
                                                </p>
                                                <div className={style.groupOptions}>
                                                    {group.options.map((opt, index) => (
                                                        <div
                                                            key={index}
                                                            className={`${style.groupOption} ${
                                                                opt.label === "no" ? style.activeOption : ""
                                                            }`}
                                                          onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleOptionClick(itemWithTransformed, opt, gIdx, index);
                                                            }}
                                                            style={{cursor: 'pointer'}}
                                                        >
                                                            <span>{opt.label}</span>
                                                            <strong>{opt.odds}</strong>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className={style.footer}>
                                        <div className={style.userCount}>
                                            <Profile2User size="20" />
                                            <span>{item.bet_count > item.user_count ? item.bet_count : item.user_count}</span>
                                        </div>
                                        <span className={style.date}>Ends: {formatEndTime(item.end_time)}</span>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        // Empty state
                        <div className={style.emptyState}>
                            <div className={style.emptyStateContent}>
                                <div className={style.emptyStateIcon}>
                                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M32 8C18.74 8 8 18.74 8 32C8 45.26 18.74 56 32 56C45.26 56 56 45.26 56 32C56 18.74 45.26 8 32 8ZM32 52C21.01 52 12 42.99 12 32C12 21.01 21.01 12 32 12C42.99 12 52 21.01 52 32C52 42.99 42.99 52 32 52Z" fill="#C1C1C1"/>
                                        <path d="M32 20C30.9 20 30 20.9 30 22V34C30 35.1 30.9 36 32 36C33.1 36 34 35.1 34 34V22C34 20.9 33.1 20 32 20Z" fill="#C1C1C1"/>
                                        <path d="M32 40C30.9 40 30 40.9 30 42C30 43.1 30.9 44 32 44C33.1 44 34 43.1 34 42C34 40.9 33.1 40 32 40Z" fill="#C1C1C1"/>
                                    </svg>
                                </div>
                                <h3 className={style.emptyStateTitle}>No Predictions Available</h3>
                                <p className={style.emptyStateText}>
                                    There are currently no betting questions available for this category. 
                                    Check back later or try a different category.
                                </p>
                                <button 
                                    className={style.emptyStateButton}
                                    onClick={() => {
                                        setActiveIndex(0);
                                        setCurrentPage(1);
                                        handleCategoryClick({ id: 0, name: 'Trending' });
                                    }}
                                >
                                    View Trending
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                <div style={{display: 'flex', justifyContent: 'center', marginTop: '20px', }}>
                    <Pagination
                    currentPage={currentPage}
                    totalCount={questionsCount}
                    pageSize={PageSize}
                    onPageChange={(page) => getMoreItemsByOffset(page)}
                    />
                </div>

            </div>
        )}

        {/* History Section */}
        {location === "History" && (
            <div className={style.historySection}>
                
               {/* Tabs */}
                <div className={style.tabs}>
                    {historyCategories.map((category, index) => (
                    <button
                        key={index}
                        className={`${style.tab} ${historyActiveIndex === index ? style.activeTab : ''}`}
                        onClick={() => handleHistoryCategoryClick(index)}
                    >
                        {category}
                    </button>
                    ))}
                </div>

                <div className={style.grid}>
                    {userBetsLoading ? (
                        // Loading state
                        Array.from({ length: 6 }).map((_, idx) => (
                            <div key={idx} className={style.skeletonCard}>
                                <div className={style.skeletonHeader}>
                                    <div className={style.skeletonLogo}></div>
                                    <div className={style.skeletonText}>
                                        <div className={style.skeletonLine}></div>
                                        <div className={style.skeletonLine} style={{width: '80%'}}></div>
                                    </div>
                                </div>
                                <div className={style.skeletonOptions}>
                                    <div className={style.skeletonOption}></div>
                                    <div className={style.skeletonOption}></div>
                                </div>
                                <div className={style.skeletonFooter}>
                                    <div className={style.skeletonFooterItem}></div>
                                    <div className={style.skeletonFooterItem}></div>
                                </div>
                            </div>
                        ))
                    ) : userBets && userBets.length > 0 ? (
                        // User bets available
                        transformUserBetsData(userBets).map((bet) => (
                            <div onClick={()=>navigate(`/bet-detail/${bet.bet_question_id}`)} key={bet.id} className={style.betCard}>
                                <div className={style.betTop}>
                                    <img src={bet.logo} alt="Logo" className={style.betLogo} />
                                    <p className={style.betQuestion}>{bet.question}</p>
                                </div>

                                <div>
                                    <div className={style.betDetails}>
                                        <span>
                                            Your bet: <strong className={`${bet.userBet === "yes" ? style.betHighlight : style.betHighlightNo}`}>{bet.userBet}</strong>
                                        </span>
                                        <span>Odd: {bet.odd}</span>
                                        <span>Stake: {bet.currency}{bet.stake.toFixed(2)}</span>
                                        <span>Potential Win: {bet.currency}{bet.potentialWin.toFixed(2)}</span>
                                    </div>

                                    {(() => {
                                        const buttonConfig = getBetButtonConfig(bet);
                                        return (
                                            <button 
                                                disabled={buttonConfig.disabled} 
                                                className={buttonConfig.className}
                                                onClick={buttonConfig.onClick}
                                            >
                                                {buttonConfig.text}
                                            </button>
                                        );
                                    })()}
                                </div>

                                <div className={style.betMeta}>
                                    <div className={style.betUsers}>
                                        <Profile2User size="20" />
                                        <span>{bet.users > bet.user_count ? bet.users : bet.user_count}</span>
                                    </div>
                                    <div className={style.betStatus}>
                                        Status: <span className={`${bet.status === "Active" ? style.betActive : bet.status === "Lost" ? style.betLost : bet.status === "Won" ? style.betWon : bet.status === "Cashed Out" ? style.betCashedOutText : bet.status === "Pending" ? style.betPending : ''}`}>{bet.status}</span>
                                    </div>
                                    <div className={style.betEnds}>
                                        Ends {bet.ends}
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        // Empty state
                        <div className={style.emptyState}>
                            <div className={style.emptyStateContent}>
                                <div className={style.emptyStateIcon}>
                                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M32 8C18.74 8 8 18.74 8 32C8 45.26 18.74 56 32 56C45.26 56 56 45.26 56 32C56 18.74 45.26 8 32 8ZM32 52C21.01 52 12 42.99 12 32C12 21.01 21.01 12 32 12C42.99 12 52 21.01 52 32C52 42.99 42.99 52 32 52Z" fill="#C1C1C1"/>
                                        <path d="M32 20C30.9 20 30 20.9 30 22V34C30 35.1 30.9 36 32 36C33.1 36 34 35.1 34 34V22C34 20.9 33.1 20 32 20Z" fill="#C1C1C1"/>
                                        <path d="M32 40C30.9 40 30 40.9 30 42C30 43.1 30.9 44 32 44C33.1 44 34 43.1 34 42C34 40.9 33.1 40 32 40Z" fill="#C1C1C1"/>
                                    </svg>
                                </div>
                                <h3 className={style.emptyStateTitle}>No Bets Found</h3>
                                <p className={style.emptyStateText}>
                                    You haven't placed any {historyCategories[historyActiveIndex].toLowerCase()} bets yet. 
                                    Start by exploring and placing bets on predictions.
                                </p>
                                <button 
                                    className={style.emptyStateButton}
                                    onClick={() => {
                                        setLocation('Explore');
                                        setActiveIndex(0);
                                        setCurrentPage(1);
                                        handleCategoryClick({ id: 0, name: 'Trending' });
                                    }}
                                >
                                    Explore Predictions
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                <div style={{display: 'flex', justifyContent: 'center', marginTop: '20px', }}>
                    <Pagination
                    currentPage={currentHistoryPage}
                    totalCount={userBetsCount}
                    pageSize={PageSize}
                    onPageChange={(page) => getMoreHistoryItemsByOffset(page)}
                    />
                </div>

            </div>
        )}

      

        </>
      );
}
 
export default PrediqoPage;